import { memo } from 'react';
import EditorNavbar from 'components/layout/EditorNavbar';
import MergeNavbar from 'components/layout/MergeNavbar';
import { IComponentContextMenu } from 'model/Application';
import { RootState } from 'app/store';
import { useSelector } from 'react-redux';

interface ISnapshotNavbarProps extends IComponentContextMenu {
    hideShowDeactivated?: boolean;
    unStickyNavbar?: boolean;
    hideSave?: boolean;
}

/**
 * Component to render the appropriate navbar based on merge state
 * Memoized to prevent unnecessary re-renders
 */
export const SnapshotNavbar = memo((props: ISnapshotNavbarProps) => {

    const stateStatus = useSelector((state: RootState) => state.status);

    const isMerging = stateStatus.merging ?? false;

    if (isMerging) {
        return <MergeNavbar key="navbar.merge" {...props} />;
    }

    return <EditorNavbar key="navbar.editor" {...props} />;
});

SnapshotNavbar.displayName = 'SnapshotNavbar';

export default SnapshotNavbar;
